<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-exec-sum-html">
      <h1 class="report-component-title">{{ title }}</h1>
      <p class="report-component-section">{{ section }}</p>
      <p class="report-component-date">Published {{ publishDate }}</p>
      <p class="report-component-author">BY: {{ cwaData.Author }}</p>
      <div class="report-component-page-title">
        <em>{{ cwaData.PageTitle }}</em>
      </div>

      <div
        class="tr-exec-sum-html__section"
        v-for="section in sections"
        :key="section.Order"
      >
        <div v-if="section.Image" class="tr-exec-sum-html__image scrollable-image">
          <img :src="section.Image" alt="Executive Summary Section Image" />
        </div>
        <div v-else class="tr-exec-sum-html__content">
          <h4 class="tr-exec-sum-html__header">{{ section.Header }}</h4>
          <p class="tr-exec-sum-html__text" v-html="section.Section"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TrExecutiveSummary',
    props: {
      title: {
        type: String,
        required: true,
      },
      cwaData: {
        type: Object,
        required: true,
      },
      section: {
        type: String,
        required: false,
      },
      publishDate: {
        type: String,
        required: false,
      },
    },
    computed: {
      sections() {
        let sections = this.cwaData.Sections;
        return sections.sort((a, b) => a.Order - b.Order);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .reportWrapper {
    margin: 3rem 0;
    font-family: 'Open Sans', sans-serif !important;
    page-break-inside: avoid;
    .report-component-title {
      font-size: 40px;
      color: var(--itr-blue);
    }
    .report-component-section {
      color: var(--itr-blue);
      font-weight: bold;
      font-size: 26px;
    }
    .report-component-date {
      color: var(--itr-grey-charcoal);
      font-size: 22px;
      font-style: italic;
    }
    .report-component-author {
      color: #a7a9ab;
      font-size: 22px;
      font-weight: bold;
      text-transform: uppercase;
    }
    .report-component-page-title {
      border-radius: 10px;
      padding: 37.5px 30px;
      color: var(--itr-white);
      background-color: var(--itr-blue-mid);
      font-size: 24px;
      line-height: 1.35em;
      margin: 20px 0 16px 0;
      font-stretch: 10%;
    }
  }
  .tr-exec-sum-html {
    &__section {
      margin: 0 0 4rem 0;
    }
    &__image {
      text-align: center;
      margin-top: 2rem;
      img {
        max-width: 1000px;
        width: 100%;
        height: auto;
      }
    }
    &__header {
      margin-bottom: 0.5rem;
      color: var(--itr-blue);
      font-size: 18px;
      font-weight: bold;
    }
    &__text {
      * {
        font-size: 18px;
        color: var(--itr-grey-dark) !important;
        background-color: transparent !important;
        font-family: 'Open Sans', sans-serif !important;
      }
    }
  }
</style>
